import * as React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import { SHARED_STYLES } from '@constants';

const queryClient = new QueryClient();

interface IAppProvider {
  children: React.ReactChild
  reactQueryClient?: QueryClient
}

export const AppProviders: React.FC<IAppProvider> = ({ children, reactQueryClient = queryClient }) => {
  return (
    <QueryClientProvider client={reactQueryClient}>
        <ThemeProvider theme={SHARED_STYLES}>
            {children}
        </ThemeProvider>
    </QueryClientProvider>
  );
};

export default AppProviders;
